


























































import {Vue, Prop, Component} from 'vue-property-decorator'
import {TodoDataServicesCollection} from '@/accessors/TodoDataServicesCollection';
import HomeViewModule from '../store/view/HomeViewModule';
import ITodoCollection, {ITodo} from '@/models/todoCollection';
import DocumentModule from '@/store/application/DocumentModule';

@Component
export default class AddDocumentDialog extends Vue {
    public documentName = 'Untitled';
    public documentCredit = '-';
    public documentTopic = 'Other';
    public documentDescription = 'Description';
    public adminId = process.env.VUE_APP_FIREBASE_ADMIN;

	public get user() {
		return this.$store.getters.user;
    }
    
    public get prompt() {
        return HomeViewModule.promptAddDocumentDialog;
    }

    public get options() {
        return HomeViewModule.documentTopics;
    }

    public closeAddDocumentDialog() {
        HomeViewModule.loadPromptAddDocumentDialog(false);
    }

    public addDocument() {
        let todoDataService = new TodoDataServicesCollection();
        let newDocument: ITodoCollection = {
            id: '',
            subject: this.documentName,
            credit: this.documentCredit,
            description: this.documentDescription,
            topic: this.documentTopic,
            todos: [{id: this.todoIdGenerator(), title:'', body:''}],
            userId: this.user.data.uid,
        }
        todoDataService.Add(newDocument).then(async (id:any) => {
            this.$router.replace({
                path: '/todo/' + id,
            });
            await DocumentModule.loadDocument(id);
        })
        this.$gtag.event('documentAdded', {event_category: `${this.documentName} in ${this.documentTopic} was added.).`, event_label: '', value: 0} );
        HomeViewModule.loadPromptAddDocumentDialog(false);
    }

	public todoIdGenerator(): string {
        return (Math.floor(Math.random() * 1000000) + 1000000).toString();
	}
}
